// extracted by mini-css-extract-plugin
export default {"buttonRating":"Rating_buttonRating__tBHcG","spancolorStar":"Rating_spancolorStar__GRecS"};